// Zapiet displays only one start–end time range by default.
// To show both lunch and dinner hours, we replace the modal text
// after the Zapiet modal is dynamically added to the DOM.
const observer = new MutationObserver(() => {
  const hours = document.querySelectorAll('.Zapiet-Modal__Hours');

  if (hours.length === 0) return;

  hours.forEach((element, index) => {
    if (index === 0) {
      element.textContent = '12:30PM - 02:00PM / 05:30PM - 08:00PM';
    }
    if (index === 1) {
      element.textContent = '12:30PM - 02:00PM / 05:30PM - 08:00PM';
    }
    if (index === 2) {
      element.textContent = '12:30PM - 02:00PM / 05:30PM - 08:00PM';
    }
    if (index === 3) {
      element.textContent = '12:30PM - 02:00PM / 05:30PM - 08:00PM';
    }
    if (index === 4) {
      element.textContent = '12:00PM - 02:30PM / 05:00PM - 08:30PM';
    }
    if (index === 5) {
      element.textContent = '12:00PM - 02:30PM / 05:00PM - 08:30PM';
    }
    if (index === 6) {
      element.textContent = '12:00PM - 02:30PM / 05:00PM - 08:30PM';
    }
  });
  observer.disconnect();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

